export const encode = (name: string) => {
  return encodeURIComponent(name);
};
